import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { acceptCustomerAgreementAndPrivacyPolicy } from '@sxm-de/dev-kits/web-sdk/domains/agreements';

interface AcceptCustomerAgreementAndPrivacyPolicyFnPayload {
    request: {
        version: string;
        language: string;
        countryCode: string;
    };
}

export type AcceptCustomerAgreementAndPrivacyPolicyFn = (
    payload: AcceptCustomerAgreementAndPrivacyPolicyFnPayload,
) => Promise<unknown>;

export function acceptCustomerAgreementAndPrivacyPolicyFn({
    dependencies,
}: DomainInitPayload): AcceptCustomerAgreementAndPrivacyPolicyFn {
    return async ({
        request,
    }: AcceptCustomerAgreementAndPrivacyPolicyFnPayload) => {
        await acceptCustomerAgreementAndPrivacyPolicy(request, dependencies);
    };
}
